import React, { useState } from 'react';
import { useAdminToast } from '../../Admin/shell/AdminToastContext';

const CopyableText = ({
    value,
    label = 'Texto',
    children,
    className = '',
    title,
}) => {
    const toast = useAdminToast();
    const [copied, setCopied] = useState(false);

    const display = children ?? value;
    const canCopy = value !== null && value !== undefined && String(value).trim() !== '';

    const handleCopy = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (!canCopy) return;
        const text = String(value);
        const ok = (msg) => {
            setCopied(true);
            toast?.current?.show({
                severity: 'success',
                summary: 'Copiado',
                detail: msg,
                life: 1800,
            });
            setTimeout(() => setCopied(false), 1500);
        };
        const fail = () => {
            toast?.current?.show({
                severity: 'error',
                summary: 'No se pudo copiar',
                detail: 'Inténtalo de nuevo',
                life: 2200,
            });
        };
        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(text).then(() => ok(`${label} copiado`), fail);
            return;
        }
        try {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            ok(`${label} copiado`);
        } catch (_) {
            fail();
        }
    };

    return (
        <span
            className={`cr-copyable ${className}`.trim()}
            onClick={(e) => e.stopPropagation()}
        >
            <button
                type="button"
                className={`cr-copy-btn${copied ? ' is-copied' : ''}`}
                onClick={handleCopy}
                title={title ?? (canCopy ? `Copiar ${label.toLowerCase()}` : 'Sin contenido')}
                disabled={!canCopy}
                aria-label={`Copiar ${label.toLowerCase()}`}
            >
                <i className={copied ? 'pi pi-check' : 'pi pi-copy'} aria-hidden="true" />
            </button>
            <span className="cr-copyable-text">{display}</span>
        </span>
    );
};

export default CopyableText;
